import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { VisibilityOff } from '@mui/icons-material';
import { useAtom, useSetAtom } from 'jotai';
import {
  openDeleteKmz,
  selectedKmz,
  selectedDisplayedKmz,
  openUploadKmz,
  partnerNetwork,
} from '../../common/atom/atoms';
import DeleteKmzComponent from './delete_kmz_popup.component';
import UploadKmzModal from './upload_kmz_modal.component';
import Swal from 'sweetalert2';
const options = ['None', 'Atria'];

const ITEM_HEIGHT = 48;

export default function LongMenu(props) {
  const { kmz } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedKmzIds, setSelectedKmzIds] = useAtom(selectedDisplayedKmz);
  const setOpenDeleteKmz = useSetAtom(openDeleteKmz);
  const [partnerNetworkValue, setPartnerNetwork] = useAtom(partnerNetwork);
  const setSelectedKmz = useSetAtom(selectedKmz);
  const setOpenUploadKmz = useSetAtom(openUploadKmz);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleDelete = () => {
    handleClose();
    setOpenDeleteKmz(true);
    setSelectedKmz(kmz);
  };
  // const handleVisibility = () => {
  //     setSelectedKmzIds((prev) =>
  //         prev.includes(kmz.id) ? prev.filter(id => id !== kmz.id) : [...prev, kmz.id]
  //     );
  // };

  const handleVisibility = () => {
    if (partnerNetworkValue) {
      // setPartnerNetwork(false)
      setSelectedKmzIds((prev) => {
        if (prev.length === 1 && prev.includes(kmz.name)) {
          return [];
        }
        return prev.includes(kmz.name)
          ? prev.filter((name) => name !== kmz.name)
          : [...prev, kmz.name];
      });
    } else {
      Swal.fire({
        title: 'Enable Partner Network',
        text: `For using "Eye Visibilty" first enable partner network`,
        icon: 'info',
        width: '300px',
        height: '300',
        customClass: {
          popup: 'small-swal',
        },
      });
      return;
    }
  };
  const handleEditKmz = () => {
    handleClose();
    setSelectedKmz(kmz);
    setOpenUploadKmz(true);
  };
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '1px' }}>
      {selectedKmzIds.includes(kmz.name) ? (
        <svg
          onClick={handleVisibility}
          width="18"
          height="20"
          style={{ marginBottom: '4px', cursor: 'pointer' }}
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4 9.99139C4.52161 7.15171 7.00952 5 10 5C12.9905 5 15.4784 7.15171 16 9.99139C15.4784 12.831 12.9905 14.9828 10 14.9828C7.00952 14.9828 4.52161 12.831 4 9.99139ZM10 12.7644C11.5315 12.7644 12.773 11.5229 12.773 9.99139C12.773 8.45991 11.5315 7.2184 10 7.2184C8.46851 7.2184 7.227 8.45991 7.227 9.99139C7.227 11.5229 8.46851 12.7644 10 12.7644ZM10 11.6552C9.0811 11.6552 8.3362 10.9103 8.3362 9.99139C8.3362 9.07248 9.0811 8.32759 10 8.32759C10.9189 8.32759 11.6638 9.07248 11.6638 9.99139C11.6638 10.9103 10.9189 11.6552 10 11.6552Z"
            fill="#757F82"
            fill-opacity="0.7"
          />
        </svg>
      ) : (
        <VisibilityOff
          onClick={handleVisibility}
          sx={{ fontSize: '1rem', color: '#9ea5a7', cursor: 'pointer' }}
        />
      )}
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        onClick={handleClick}
        size="small" // Smaller button
      >
        <MoreVertIcon fontSize="small" />
      </IconButton>
      <Menu
        id="long-menu"
        MenuListProps={{
          'aria-labelledby': 'long-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          paper: {
            style: {
              maxHeight: ITEM_HEIGHT * 4.5,
              // width: '20ch',
            },
          },
        }}
      >
        <MenuItem onClick={handleEditKmz} disableRipple>
          <EditIcon />
          <div
            style={{
              marginLeft: '5px',
              color: '#090C0D',
              fontSize: 14,
              fontFamily: 'Poppins',
              fontWeight: '400',
              wordWrap: 'break-word',
            }}
          >
            Edit KMZ
          </div>
        </MenuItem>
        <MenuItem onClick={handleDelete} disableRipple>
          <DeleteIcon sx={{ color: '#FF6066' }} />
          <div
            style={{
              marginLeft: '5px',
              color: '#FF6066',
              fontSize: 14,
              fontFamily: 'Poppins',
              fontWeight: '400',
              wordWrap: 'break-word',
            }}
          >
            Delete KMZ
          </div>
        </MenuItem>
      </Menu>
    </div>
  );
}
